import _ from 'lodash';
import {DocMeta} from '@doc-tools/components';
import Cookies from 'js-cookie';

export function strToBoolean(str: string | boolean) {
    if (typeof str === 'boolean') {
        return str;
    }

    return str === 'true';
}

function getCookieSettingName(settingName: string) {
    return `docs-viewer-${settingName}`;
}

function deleteCookie(name?: string) {
    if (name) {
        Cookies.remove(name);
    }
}

export function setSettingToCookie(settingName: string, value: unknown) {
    const cookieSettingName = getCookieSettingName(settingName);

    deleteCookie(cookieSettingName);

    Cookies.set(cookieSettingName, String(value), {expires: 365, domain: window.location.hostname});
}

export function getSystemVariableValue(meta: DocMeta, name: string) {
    return _.get(meta, `__system.${name}`);
}
